import { paletteBase } from '@abg/kit-base';
import { AbgSxProps } from '@abg/typings';

import { AncillariesPageType } from '../../../shared/constants';

export const containerStyling: AbgSxProps = {
  gridRow: 1,
  display: 'flex',
  flexDirection: 'column',
  position: 'relative',
};

export const imageContainerStyling: AbgSxProps = {
  height: '130px',
  margin: '8px 8px 0',
  position: 'relative',
  overflow: 'hidden',
};

export const headerStyling = (pageType: AncillariesPageType): AbgSxProps => ({
  padding: { xs: '16px 16px 0', sm: '16px 24px 0' },
  ...(pageType === AncillariesPageType.AddOns && {
    backgroundColor: '#FFF',
  }),
  display: 'flex',
  flexDirection: 'column',
  flex: '1',
});

export const titleContainerStyling = (
  pageType: AncillariesPageType,
): AbgSxProps => ({
  display: 'flex',
  justifyContent: 'space-between',
  alignItems: 'center',
  padding: pageType === AncillariesPageType.AddOns ? '4px 0 4px' : '8px 0 4px',
  marginBottom: '2px',
  '&.MuiFormControlLabel-root': {
    marginLeft: 0,
    marginRight: 0,
  },
});

export const radioButtonStyling: AbgSxProps = {
  padding: '0',
  backgroundColor: paletteBase.white100,
  alignSelf: 'flex-start',
  marginLeft: '8px',
};

export const checkboxButtonStyling: AbgSxProps = {
  padding: '0',
  backgroundColor: paletteBase.white100,
  alignSelf: 'flex-start',
  marginLeft: '8px',
  borderRadius: '2px',
  '&:hover': {
    backgroundColor: 'transparent',
  },
  '& .MuiTouchRipple-root': {
    display: 'none',
  },
};

export const checkboxIconStyling = (theme: {
  palette: { secondary: { dark: string } };
}) => ({
  width: '24px',
  height: '24px',
  borderRadius: '2px',
  border: `1px solid ${theme.palette.secondary.dark}`,
});

export const checkboxCheckedIconStyling = (theme: {
  palette: { secondary: { dark: string } };
}) => ({
  width: '24px',
  height: '24px',
  borderRadius: '2px',
  backgroundColor: theme.palette.secondary.dark,
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
});

export const descriptionStyling: AbgSxProps = {
  flex: '1',
  marginBottom: '20px',
  '& p': {
    margin: 0,
  },
};

export const recommendedStyling: AbgSxProps = {
  height: 'fit-content',
  padding: '4px 8px',
  alignSelf: 'center',
  position: 'absolute',
  top: '-13px',
};
